import instance from "@/services/api";

export const frameTypesAPI = {
  async getList() {
    return await instance()
      .get("/floor_map/frame/frame_type_read/")
      .then((res) => res?.data);
  },
  async getFrameTypeParamsList(frame_type_id) {
    return await instance()
      .get(`/floor_map/frame/${frame_type_id}/link_read/`)
      .then((res) => res?.data);
  },
  async getParamFrameTypes() {
    return await instance()
      .get(`/floor_map/frame/param_type/`)
      .then((res) => res?.data);
  },
  async updateFrameLinkParam(body) {
    return await instance()
      .post("/floor_map/frame/link_upd/", body)
      .then((res) => res?.data);
  },
  async deleteBalance(balance_id) {
    return await instance()
      .delete(`/finance/balance/${balance_id}/del/`)
      .then((res) => res?.data);
  },
  async onDeleteFrameTypeParam(frame_param_link_id) {
    return await instance()
      .delete(`/floor_map/frame/${frame_param_link_id}/delete/`)
      .then((res) => res?.data);
  },
};
